import { takeLatest } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { fetchHotelAvailabilitySaga } from "./fetchHotelAvailabilitySaga";
import { fetchViewHotelsNearLocationsSaga } from "./fetchViewHotelsNearSaga";

export function* watchFetchHotelAvailability() {
  yield takeLatest(
    actionTypes.FETCH_INITIAL_HOTEL_AVAILABILITY,
    fetchHotelAvailabilitySaga
  );
  yield takeLatest(
    actionTypes.FETCH_MORE_HOTEL_AVAILABILITY,
    fetchHotelAvailabilitySaga
  );
}

export function* watchFetchViewHotelsNearLocations() {
  yield takeLatest(
    actionTypes.FETCH_VIEW_HOTELS_NEAR_LOCATION_CATEGORIES,
    fetchViewHotelsNearLocationsSaga
  );
}
